import React from 'react';

const ErrorIcon = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="24" height="24" rx="12" fill="#E93A46"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M15.9697 6.96967C16.2626 6.67678 16.7373 6.67678 17.0302 6.96967C17.3231 7.26257 17.3231 7.73734 17.0302 8.03022L13.0605 11.9999L17.0302 15.9697C17.3231 16.2626 17.3231 16.7373 17.0302 17.0302C16.7373 17.3231 16.2626 17.3231 15.9697 17.0302L11.9999 13.0605L8.03022 17.0302C7.73734 17.3231 7.26257 17.3231 6.96967 17.0302C6.67678 16.7373 6.67678 16.2626 6.96967 15.9697L10.9394 11.9999L6.96967 8.03022C6.67678 7.73732 6.67678 7.26256 6.96967 6.96967C7.26256 6.67678 7.73732 6.67678 8.03022 6.96967L11.9999 10.9394L15.9697 6.96967Z" fill="#333333"/>
  </svg>
);

export default ErrorIcon;
